<template>
  <h2 class="notice-board-head">SCHOOL NOTICE BOARD</h2>
  <div
    v-for="announcement in announcements"
    :key="announcement.id"
    class="notice-board-snippet"
  >
    <SingleAnnouncement :announcement="announcement" />
  </div>
</template>

<script>
import SingleAnnouncement from './SingleAnnouncement.vue'
export default {
  components: { SingleAnnouncement },
  props: ['announcements']
}
</script>

<style>
.notice-board-head {
  color: whitesmoke;
  background: #333;
  padding: 30px;
  margin: 0 auto;
}
.notice-board-snippet {
  color: whitesmoke;
  background: #333;
  padding: 20px;
  margin: 0 auto;
}
</style>
